import {UrlService} from "@nuskin/ns-util";
import axios from 'axios'

const downConvertAgreedToTerms = async (sapId) => {
    let retVal = true;
    const oktaTokens = sessionStorage.getItem("oktaTokens") || '{}';
    const { accessToken } = JSON.parse(oktaTokens);

    if (accessToken) {
        try {
            const result = await axios.get(
                `${UrlService.getApisUrl()}/account-enrollment/agreement-terms/${sapId}`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            )
            retVal = result && result.data && result.data.agreedTerms === true;
        } catch (e) {
            console.error('agreement-terms check failed', e)
        }
    }

    return retVal
}

const setDownConvertAgreedToTerms = async (sapId) => {
    let succeeded = true
    const oktaTokens = sessionStorage.getItem("oktaTokens") || '{}';
    const { accessToken } = JSON.parse(oktaTokens);

    if (accessToken) {
        try {
            await axios.put(
                `${UrlService.getApisUrl()}/account-enrollment/agreement-terms/${sapId}`,
                {},
                {headers: {Authorization: `Bearer ${accessToken}`}}
            )
        } catch (e) {
            console.error('Failed setting agreement to terms', e);
            succeeded = false;
        }
    }
    return succeeded;
}

export default {
    downConvertAgreedToTerms,
    setDownConvertAgreedToTerms
};
